module.exports = __webpack_public_path__ + "static/media/MyProject_logo.c9bca56c.svg";